import { BFormFile } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBFormFile = createEgBootstrapProxy("EgBFormFile", BFormFile);
